module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAdCAIAAACMkBMGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAH5JREFUeNpiPHjg4KFDBxkGDbCzs2cBOqiluWXwuKmmloGJYfCBUTeNumnUTfQHLFx/fppKCA4eBwHdw6L48Pa81/8Hj5uuPLw9mp5G3TTqplE3DdpyXMXiulLpm8HjoB+Hr4/G3aibRt006qZBW2b+F/G/dngQOQjoHoAAAwDFMh9FiRknIgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/select-img/de.png
// module id = VNHL
// module chunks = 1